module.exports = __webpack_public_path__ + "img/usa-genitourinary-diseases-female.51583f0e.png";